import React from "react"
import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"
import Checkbox from "@mui/material/Checkbox"
import ListItemText from "@mui/material/ListItemText"
import Popper from "@mui/material/Popper"
import { useLocalization } from "../../providers/LocalizationProvider"

const StyledPopper = (props) => <Popper {...props} style={{ zIndex: 1300 }} />

export default function ColumnToggleSelect({
    allColumns,
    userHiddenColumns,
    setUserHiddenColumns,
    width = "100%", // make it configurable
}) {
    const options = React.useMemo(() => allColumns.filter((c) => !c.isBackendHidden), [allColumns])
    const { voiceiiTags } = useLocalization()

    const value = React.useMemo(
        () => options.filter((col) => !userHiddenColumns.includes(col.id)),
        [options, userHiddenColumns],
    )

    const handleChange = (event, newValue) => {
        if (newValue.some((c) => c.id === "__all__")) {
            if (value.length === options.length) {
                setUserHiddenColumns(options.map((c) => c.id)) // deselect all
            } else {
                setUserHiddenColumns([]) // select all
            }
            return
        }

        const visibleIds = newValue.map((c) => c.id)
        const hiddenIds = options.filter((c) => !visibleIds.includes(c.id)).map((c) => c.id)

        setUserHiddenColumns(hiddenIds)
    }

    return (
        <Autocomplete
            className="h-25"
            multiple
            disableCloseOnSelect
            options={[{ id: "__all__", Header: voiceiiTags("Select All") }, ...options]}
            value={value}
            onChange={handleChange}
            popperComponent={StyledPopper}
            getOptionLabel={(option) => option.Header || option.id}
            isOptionEqualToValue={(option, v) => option.id === v.id}
            renderOption={(props, option, { selected }) => {
                if (option.id === "__all__") {
                    const allSelected = value.length === options.length
                    return (
                        <li {...props}>
                            <Checkbox
                                checked={allSelected}
                                indeterminate={value.length > 0 && value.length < options.length}
                            />
                            <ListItemText primary={allSelected ? voiceiiTags("Deselect All") : voiceiiTags("Select All")} />
                        </li>
                    )
                }

                return (
                    <li {...props}>
                        <Checkbox checked={selected} tabIndex={-1} size="small" sx={{ mr: 1 }} />
                        <ListItemText primary={option.Header} className="text-capitalize" />
                    </li>
                )
            }}
            renderTags={(selected) => <></>}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={voiceiiTags("Columns")}
                    placeholder={voiceiiTags("Search or select...")}
                    size="md"
                />
            )}
            ListboxProps={{
                style: { maxHeight: 350, overflow: "auto" },
            }}
            sx={{
                width,
            }}
        />
    )
}
